<div class="row">
    <div class="col-12">
        <div class="d-flex flex-column">
            <div class="d-flex justify-content-center w-100">
                <app-shared-policy-table
                    [dataSource]="dataSource"
                    [displayedColumns]="columns"
                    [component]="'Policies'"
                    [displayLoadingIndicator]="loading"
                    [propertyHasPrimaryPolicy]="true"
                    [tableLength]="tableLength"
                    [getStatusColor]="getPolicyPrimaryColorForTable"
                    [hidePointer]="true"
                    (actionClickedEvent)="onViewRangesOpenClick($event)"
                    (editPolicyClickEvent)="onEditPolicyClick($event)"
                    (updatePolicyClickEvent)="onUpdatePrimaryPolicyClick($event)"
                    (deletePolicyClickEvent)="onDeletePolicyClick($event)">
                </app-shared-policy-table>
            </div>
        </div>
    </div>
</div>